const isCrmUser = (user) => {
  return user.type === "crmLists";
};

const getAssigneeIcon = (user) => {
  if (user.group) return "users";
  if (isCrmUser(user)) return "add user";
  return "user circle";
};

const byUserType = (a, b) => {
  const isGroupA = Boolean(a.group);
  const isGroupB = Boolean(b.group);
  const isCrmUserA = isCrmUser(a);
  const isCrmUserB = isCrmUser(b);

  if (isGroupA !== isGroupB) return isGroupA ? -1 : 1;
  if (isCrmUserA !== isCrmUserB) return isCrmUserA ? 1 : -1;

  return 0;
};

const toDropdownOption = ({ id, name, icon }) => {
  return {
    key: id,
    value: id,
    text: name,
    icon: icon,
  };
};

export function useAssigneeOptions(assignee) {
  return assignee
    .sort(byUserType)
    .map((u) => {
      return { ...u, icon: getAssigneeIcon(u) };
    })
    .map(toDropdownOption);
}

export default useAssigneeOptions;
